<template>
    <div>

        <el-card>
            <div style="display: flex;">
                <span style="width: 100px;margin-right: 10px; padding-top: 10px;">科目:</span>
                <el-select v-model="input66"  placeholder="请选择科目" filterable clearable @change="seachteacher">
                    <el-option v-for="item in subjectArr" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
                </el-select>
            </div>
        </el-card>
        
        
        <div class="chart-container">
           <el-card>
               <h3 style="width: 100%;text-align: center;">可排课时数</h3>
               <div ref="chart" class="chart-container"></div>
           </el-card>
        </div>

        <div class="chart-container" v-if="subjectData.length <= 0" style=" width: 100%; height: 800px;position: absolute;  top: 0;top: 44%; left: 5%; ">
            <el-empty :image-size="200"></el-empty>
        </div>


        <el-dialog append-to-body title="数据详情" :visible.sync="showView" width="80%" @close="closeEditDialog">
            <el-card>
                <el-input v-model="input1" @input="handleInput"  placeholder="搜索"  clearable></el-input>
                <el-table :data="tableData" border  height="700" style="width: 100%;margin-top: 20px;" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
                    <el-table-column prop="categoryName" label="科目" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="rankName" label="职级" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="teacherName" label="姓名" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="yetNum" label="已排课时" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="mayNum" label="可排课时" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="" label="备注" show-overflow-tooltip></el-table-column>
                </el-table>
                <!-- <div class="footer-button" style="margin-top: 15px; text-align: center;">
                    <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
                    :current-page.sync="pageNums" :page-size="pageSizes" layout="total, prev, pager, next"
                    :total="totals"></el-pagination>
                </div> -->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeEditDialog" size="small">关闭</el-button>
                </div>
            </el-card>
        </el-dialog>


    </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import * as echarts from 'echarts'
import loadingUtils from "../utils/loading";


export default {
    name: 'AvailableClassScheduling',
    components: {
      
    },

    data() {
        return {
            input1: '',
            tableData: [],
            showView: false,

            pageNums: 1,
            pageSizes: 10,
            totals: 0,


            subjectArr: [],
            input66: '',
            subjectData: [],

            chartInstance: null,

            categoryName: '',

        };
    },

    watch: {
        subjectData: {
          handler() {
              this.$nextTick(() => {
                  this.renderChart()
              })
          },
          deep: true
        }
    },

    

    mounted() {
      axios.get(`${ apiBaseUrl }/schedule/teacherCategorylist`,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ 
        this.subjectArr = res.data.data
      })
      this.handleInit()
      this.$nextTick(() => {
           this.initChart()
      })
      window.addEventListener('resize', this.handleResize)
    },


    methods: {


        handleInit(){
            loadingUtils.startLoading();

            axios.post(`${apiBaseUrl}/schedule/queryScheduleHour`, { "categoryId": this.input66 ? this.input66 : null, },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
                if (response.data && response.data.code === 200) {
                    this.subjectData = response.data.data
                    setTimeout(() => {
                      loadingUtils.endLoading()
                    }, 500)
                    this.$message.success(response.data.message || response.data.meg)
                } else {
                  setTimeout(() => {
                    loadingUtils.endLoading()
                  }, 500)
                  this.subjectData = []
                  this.$message.error(response.data.message || response.data.meg);
                }
            }).catch((error) => {
                this.subjectData = []
                this.$message.error(error);
                setTimeout(() => {
                  loadingUtils.endLoading()
                }, 500)
            }); 
        },

        handleCurrentChanges(val) {
            this.pageNums = val
        },

        handleSizeChanges(val) {
            this.pageSizes = val
        },

        handleInput() {
            this.handleView()
        },

        closeEditDialog() {
            this.showView = false
            this.input1 = ''
        },


        seachteacher() {
           this.handleInit()
        },

        format(percentage) {
            return percentage
        },


        initChart() {
            this.chartInstance = echarts.init(this.$refs.chart)
            this.renderChart()
        },

        renderChart() {
            if (!this.chartInstance) return

            const option = {
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: { show: false },
                grid: {
                    left: '10%',
                    right: '5%',
                    top: '8%',
                    bottom: '8%',
                },
                xAxis: {
                    type: 'value',
                    axisLabel: { show: false },
                    splitLine: { show: false },
                    axisLine: { show: false },
                    axisTick: { show: false  }
                },
                yAxis: {
                    type: 'category',
                    data: this.subjectData.map(item => item.categoryName),
                    axisLabel: {
                        margin: 80,
                        align: 'left',   // 左对齐
                        verticalAlign: 'middle', // 垂直居中
                        fontSize: 16,
                        color: '#333',
                        // 添加鼠标样式
                        cursor: 'pointer',
                        // 添加点击效果
                        fontWeight: 'normal',
                        rich: {
                            a: {
                                fontWeight: 'bold'
                            }
                        }
                    },
                    axisLine: { show: false },
                    axisTick: { show: false },
                    // 添加轴线点击事件
                    triggerEvent: true
                },
                series: [
                    {
                        name: '可排课时数',
                        type: 'bar',
                        data: this.subjectData.map(item => item.mayNum),
                        barWidth: this.subjectData.length === 1 ? 20 : '60%',
                        itemStyle: {
                          color: '#1890ff'
                        },
                        label: {
                            show: true,
                            position: 'right',
                            distance: 5,
                            formatter: '{c}'
                        },
                        emphasis: {
                          focus: 'series'
                        },
                        animation: true,
                    }
                ]
            }

            this.chartInstance.setOption(option, true)
            this.chartInstance.on('click', (params) => {
                console.log(params, '111111111111')
                if (params.componentType === 'series') {
                    const { name: categoryName, value } = params
                    this.categoryName = categoryName 
                    this.handleView(categoryName)
                    console.log('点击了柱状图:', categoryName, '数值:', value)
                }
                else if (params.componentType === 'yAxis') {
                    const categoryName = params.value
                    const item = this.subjectData.find(d => d.categoryName === categoryName)
                    if (item) {
                        this.categoryName = categoryName 
                        this.handleView(categoryName)
                        console.log('点击了科目:', categoryName, '数值:', item.value)
                    }
                }
            })

       },

       handleView() {
           this.showView = true
           let categoryId = this.subjectData.find(d => d.categoryName === this.categoryName).categoryId
           axios.post(`${apiBaseUrl}/schedule/queryScheduleHourInfo`, { "categoryId": categoryId ? categoryId : null, teacherName: this.input1 ? this.input1 : '' }, {headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
                if (response.data && response.data.code === 200) {
                    this.tableData = response.data.data
                } else {
                  this.tableData = []
                  this.$message.error(response.data.message || response.data.meg);
                }
            }).catch((error) => {
                this.tableData = []
                this.$message.error(error);
            }); 
       },
       
        handleResize() {
            if (this.chartInstance) {
                this.chartInstance.resize()
            }
        }
    },


    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
        if (this.chartInstance) {
          this.chartInstance.dispose()
        }
    },

}

</script>

<style scope lang="less">

.chart-container {
  width: 100%;
  height: 800px;
  border-radius: 8px;
}

</style>


// WEBPACK FOOTER //
// src/AvailableClassScheduling/AvailableClassScheduling.vue